import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  InputAdornment,
  IconButton,
  Icon,
  CircularProgress,
} from '@material-ui/core';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Actions from '../../../store/ducks/userProfile';
import AuthActions from '../../../store/ducks/auth';
import Logo from '../../../components/Logo';
import useStyles from './styles';

const ResetPassword = props => {
  const {
    match: {
      params: { token },
    },
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { email, status } = useSelector(({ userProfile }) => userProfile);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    newPassword: '',
    confirmNewPassword: '',
  });
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmNewPassword: false,
  });

  const handleChange = useCallback(
    ({ target }) =>
      setValues(oldValues => ({
        ...oldValues,
        [target.name]: target.value,
      })),
    [],
  );

  const handleShowPassword = useCallback(
    type =>
      setShowPassword(oldShowPassword => ({
        ...oldShowPassword,
        [type]: !oldShowPassword[type],
      })),
    [],
  );

  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      setLoading(true);
      if (values.newPassword && values.confirmNewPassword) {
        if (values.newPassword !== values.confirmNewPassword) {
          enqueueSnackbar('As senhas precisam ser iguais.', {
            variant: 'error',
          });
          setLoading(false);
        } else if (values.newPassword === values.confirmNewPassword) {
          const credentials = {
            token,
            newPassword: values.newPassword,
          };
          dispatch(Actions.resetUserPassword(credentials));
        }
      }
    },
    [
      dispatch,
      enqueueSnackbar,
      token,
      values.confirmNewPassword,
      values.newPassword,
    ],
  );

  useEffect(() => {
    if (!email) {
      dispatch(Actions.canUserResetPassword(token));
    }
  }, [dispatch, email, token]);

  useEffect(() => {
    if (status.msg && status.variant) {
      setLoading(false);
      if (status.variant === 'error' && !email) {
        enqueueSnackbar(status.msg, {
          variant: status.variant,
        });
        history.push('/');
        dispatch(Actions.clearStatus());
      }
      if (status.variant === 'success' && email) {
        const credentials = {
          email,
          password: values.newPassword,
          keepConnected: false,
        };
        enqueueSnackbar(status.msg, {
          variant: status.variant,
        });
        dispatch(Actions.clearStatus());
        history.push('/');
        dispatch(AuthActions.requestLogin(credentials));
      }
    }
  }, [dispatch, email, enqueueSnackbar, history, status, values.newPassword]);

  if (!email && !status.msg) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <CircularProgress
          className="btn-login-loading"
          color="inherit"
          size={34}
        />
      </Box>
    );
  }

  return (
    <Box className={classes.container}>
      <Helmet>
        <title>Definir nova senha</title>
      </Helmet>
      <Box className="logo-container">
        <Logo className="logo-img" />
      </Box>
      <Box className="description-container">
        <Typography className="description" variant="body2">
          Insira uma nova senha de acesso:
        </Typography>
      </Box>
      <FormControl component="form" onSubmit={handleSubmit}>
        <Box className="input-container email">
          <TextField
            className="input"
            id="newPassword"
            name="newPassword"
            variant="outlined"
            type={showPassword.newPassword ? 'text' : 'password'}
            label="Nova senha"
            value={values.newPassword}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    aria-label="toggle password visibility"
                    type="button"
                    onClick={e => {
                      e.preventDefault();
                      handleShowPassword('newPassword');
                    }}
                  >
                    <Icon>
                      {showPassword.newPassword
                        ? 'visibility_off'
                        : 'visibility'}
                    </Icon>
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box className="input-container email">
          <TextField
            className="input"
            id="confirmNewPassword"
            name="confirmNewPassword"
            variant="outlined"
            type={showPassword.confirmNewPassword ? 'text' : 'password'}
            label="Confirmação de senha"
            value={values.confirmNewPassword}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    aria-label="toggle password visibility"
                    type="button"
                    onClick={e => {
                      e.preventDefault();
                      handleShowPassword('confirmNewPassword');
                    }}
                  >
                    <Icon>
                      {showPassword.confirmNewPassword
                        ? 'visibility_off'
                        : 'visibility'}
                    </Icon>
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box className="btn-recovery-container">
          <Button
            type="submit"
            className="btn-recovery"
            variant="contained"
            color="primary"
            size="large"
          >
            {loading ? (
              <CircularProgress
                className="btn-login-loading"
                color="inherit"
                size={24}
              />
            ) : (
              'Salvar nova senha'
            )}
          </Button>
        </Box>
      </FormControl>
    </Box>
  );
};

export default ResetPassword;
